module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p9.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "fm1"
  }, [_c('b', [_vm._v("Juliet Murphy, MBA")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_vm._v("(714) 642-3777")])]), _c('p', {
    staticClass: "txc"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "http://www.julietmurphy.com",
      "id": "AZ9",
      "target": "_blank"
    }
  }, [_vm._v("www.julietmurphy.com")])]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Juliet Murphy, MBA and MA – Career Development, is the President of a career management company, Juliet Murphy Career Development (JMCD), delivering career solutions to young adults, executives and corporations. Her specialties include millennial career development, with Juliet having a strong background in working with new college graduates. Her website is: "), _c('i', [_c('a', {
    attrs: {
      "href": "http://www.julietmurphy.com",
      "id": "AMS",
      "target": "_blank"
    }
  }, [_vm._v("www.julietmurphy.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a32a6c72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter10.vue
// module id = 93
// module chunks = 0